import { SPECIAL_TYPE_TOGGLE_MORE, MORE, LESS } from './constants';

export const generateShowMoreRow = ({ valueField, onClick }) => ({
  type: SPECIAL_TYPE_TOGGLE_MORE,
  [valueField]: MORE,
  onClick,
});

export const generateShowLessRow = ({ valueField, onClick }) => ({
  type: SPECIAL_TYPE_TOGGLE_MORE,
  [valueField]: LESS,
  onClick,
});
